<div class="workSpace">
  <!--nombre y filtro-->
  <div class="w3-container w3-containertemplate" style="height: 7%;">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda w3-quarter">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{
            'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect
          | translate }} </span>
      </div>
    </div>
  </div>
  <!--CONTENIDO TABLERO  -->
  <div class="w3-center tablero" [ngClass]="{'fondoCuestionario': !listaCuestionario}">

    <!-- TARJETAS CUESTIONARIOS ASIGNADOS -->
    @if (listaCuestionario) {
    <div class="conteTarjetas">
      <div class="contenedor-busqueda" style="margin-bottom: 20px;">
        <mat-form-field appearance="outline" style="width: 60%; height: 30%;">
          <mat-label>Buscar...</mat-label>
          <input matInput type="text" placeholder="Ej. Control interno" [(ngModel)]="filtroBusqueda"
            (input)="aplicarFiltro()">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      <div class="tarjetas" style="min-height: 72vh; max-height: 75vh; overflow: scroll;">
        @for (c of cuesAsigFiltrados; track c.id) {
        <mat-card class="tarjeta-cuestionario">
          <div class="fondoTarjeta" >
            <div class="contIcono">
            </div>
            <div class="nombre-cuestionario">{{c.cuesNombre}}</div>

          </div>
          <div class="infoTarjeta">
            <div class=" infDate w3-row w3-margin-left-filter w3-subtitulo">{{getFecha(c.fechaIni)}}</div>
            @if (c.estatus === 'open') {
            <div class="estatusCuest enCurso w3-row">En curso</div>
            }@else if (c.estatus === 'close') {
            <div class="estatusCuest completado w3-row">Completado</div>
            }@else if (c.estatus === 'pending') {
            <div class="estatusCuest pendiente w3-row">Pendiente</div>
            }
            @if (c.estatus === 'open') {
            <button class="btnCuest btnCurso" (click)="responderCues(c)">Responder</button>
            }@else if (c.estatus === 'close') {
            <button class="btnCuest btnCompleto" (click)="descargarReporte(c)">Ver resultados</button>
            }@else if (c.estatus ==='pending') {
            <button class="btnCuest btnPendiente">No disponible</button>
            }
          </div>
        </mat-card>
        }
      </div>
    </div>
    }
    <!-- RESPONDER CUESTIONARIO SELECCIONADO -->
    @if (!listaCuestionario) {
    <div class="conteCuestionario">
      <div class="r3-row w3-center" style="height: 10%; margin-top: 1%; margin-bottom: 1%;">
        <div class="titulo w3-threequarter">{{cuesSelec.cuesNombre}}</div>
        <div class="w3-rest w3-right-align_rest" style="padding-right: 10px;">
          <mat-icon (click)="mensajeSugerencia('cues.cuestionarios.sugerencia');" class="w3-button w3-dropdown-click"
            matTooltip="{{'acciones.sugerencia' | translate}}" [ngStyle]="{'color':'gray'}">info</mat-icon>
          <mat-icon class="w3-button w3-dropdown-click" [matMenuTriggerFor]="menuGuardar"
            [ngStyle]="{'color':'gray'}">more_vert</mat-icon>
        </div>
        <mat-menu #menuGuardar="matMenu">
          <button (click)="guardarRespuestas();" appearance="outlined" class="mat-menu-item" mat-menu-item
            class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">save</mat-icon> <!--quiz-->
            <span>{{'cues.cuestionarios.guardarRes' | translate}}</span>
          </button>
          <button (click)="terminar();" appearance="outlined" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">fact_check</mat-icon>
            <span>{{'cues.cuestionarios.terminar' | translate}}</span>
          </button>
        </mat-menu>
      </div>
      <div class="areaCues w3-center">
        <mat-tab-group mat-stretch-tabs="false" fitInkBarToContent mat-align-tabs="start" class="w3-scroll custom-tabs-naranja"
          style="height: 99%;">
          @for (componente of respCuestionario['elementos']; track c; let c = $index) {
          <div class="areaCues w3-row w3-scroll">
            <mat-tab label="{{componente.name}}" style="font-size: 30pt !important; ">
              <!-- CUESTIONARIO CON ELEMENTOS -->
              <!-- <mat-accordion class="example-headers-align" style="height: 95%;"> -->
              @for (elemento of componente.elementos; track elemento.id; let e = $index) {
              <mat-expansion-panel class="textoNoWrap panelExp" id="{{elemento.id}}" [expanded]="selec === e"
                (opened)=" selec = e; posScroll(elemento.id);"> <!---->
                <mat-expansion-panel-header class="alinLeft ">
                  <mat-panel-title class="titElem">
                    {{elemento.name}} 
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-questions [elemento]="elemento" [respuestasGuardas]="hojaRespuesta" [hojaRes]="hojaRespuesta"
                  [bndIncompleto]="incompleto"
                  (eventContestacion)="hojaRespuestas($event[0], $event[1], $event[2])"></app-questions>
              </mat-expansion-panel>
              }
              <!-- </mat-accordion> -->
              <!-- CUESTIONARIO SIN ELEMENTOS -->
              @if (componente.preguntas.length !== 0) {
              <app-questions [elemento]="componente" [respuestasGuardas]="hojaRespuesta" [hojaRes]="hojaRespuesta"
                [bndIncompleto]="incompleto" (eventContestacion)="hojaRespuestas($event[0], $event[1], $event[2])"></app-questions>
              }
            </mat-tab>
          </div>
          }
        </mat-tab-group>
        <!-- <div class="w3-row w3-right" style="font-size: smaller; color: red;">{{'cues.cuestionarios.requerido'|translate}}</div> -->
      </div>
    </div>
    }
  </div>
</div>